import { APP_INITIALIZER, NgModule } from '@angular/core'
import { ReferralService } from './referral.service'

@NgModule({
    providers: [
        ReferralService,
        {
            provide: APP_INITIALIZER,
            useFactory: (referralService: ReferralService) => () => {
                return referralService.bootstrap()
            },
            deps: [ReferralService],
            multi: true,
        },
    ],
})
export class ReferralModule {}
